export const Paths = {
  login: "/index",
};
